import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export const Footer = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api
      .get("/categories/list")
      .then(({ data }) => setCategories(data.categories))
      .catch(() => setCategories([]));
  }, []);

  return (
    <footer className="border-t border-slate-200 bg-slate-50 mt-auto">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-2">
              <div className="h-7 w-7 rounded-lg bg-brand flex items-center justify-center">
                <div className="h-3 w-3 rounded-full border-2 border-white" />
              </div>
              <span className="font-display font-extrabold text-lg tracking-tight text-slate-900">
                IndiaBusiness<span className="text-brand">Circle</span>
              </span>
            </div>
            <p className="text-sm text-slate-500 max-w-sm">
              The trusted network for Indian businesses. Discover. Connect. Grow.
            </p>
          </div>

          {/* Explore */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500 mb-4">Explore</h3>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/directory" className="text-slate-600 hover:text-brand transition-colors">Directory</Link></li>
              <li><Link to="/discover" className="text-slate-600 hover:text-brand transition-colors">Discover</Link></li>
              <li><Link to="/feed" className="text-slate-600 hover:text-brand transition-colors">Feed</Link></li>
              <li><Link to="/news" className="text-slate-600 hover:text-brand transition-colors">News</Link></li>
              <li><Link to="/categories" className="text-slate-600 hover:text-brand transition-colors font-semibold">All Categories</Link></li>
            </ul>
          </div>

          {/* Browse by Category */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500 mb-4">Browse by Category</h3>
            <ul data-testid="footer-categories" className="space-y-2.5 text-sm">
              {categories.slice(0, 8).map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/categories/${c.slug}`}
                    data-testid={`footer-cat-${c.slug}`}
                    className="text-slate-600 hover:text-brand transition-colors"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-slate-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-slate-400">
            © {new Date().getFullYear()} IndiaBusinessCircle. All rights reserved.
          </p>
          <div className="flex items-center gap-5 text-xs font-semibold">
            <Link to="/privacy" data-testid="footer-privacy-link" className="text-slate-500 hover:text-brand transition-colors">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms-link" className="text-slate-500 hover:text-brand transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
